export default {
  formId: "checkoutForm",
  formField: {
    firstName: {
      name: "firstName",
      label: "Fornavn",
    },
    lastName: {
      name: "lastName",
      label: "Efternavn",
    },
    companyName: {
      name: "companyName",
      label: "Firmanavn (valgfri)",
    },
    cvrNumber: {
      name: "cvrNumber",
      label: "CVR-nr (valgfri)",
    },
    eanNumber: {
      name: "eanNumber",
      label: "EAN-nr (valgfri)",
    },
    address: {
      name: "address",
      label: "Adresse",
    },
    postCode: {
      name: "postCode",
      label: "Postnr",
    },
    city: {
      name: "city",
      label: "By",
    },
    country: {
      name: "country",
      label: "Land",
    },
    telephone: {
      name: "telephone",
      label: "Telefon",
    },
    email: {
      name: "email",
      label: "E-mailadresse",
    },
    reference: {
      name: "reference",
      label: "Reference (valgfri)",
    },
    comments: {
      name: "comments",
      label: "Bemærkninger (valgfri)",
    },
    shipping: {
      shippingName: {
        name: "shippingName",
        label: "Navn / Firma",
      },
      shippingAddress: {
        name: "shippingAddress",
        label: "Adresse",
      },
      shippingPostCode: {
        name: "shippingPostCode",
        label: "Postnr",
      },
      shippingCountry: {
        name: "shippingCountry",
        label: "Land",
      },
      shippingContactPerson: {
        name: "shippingContactPerson",
        label: "Kontaktperson",
      },
      shippingAddress2: {
        name: "shippingAddress2",
        label: "Adresse 2",
      },
      shippingCity: {
        name: "shippingCity",
        label: "By",
      },
      shippingPhone: {
        name: "shippingPhone",
        label: "Telefon",
      },
      shippingEmail: {
        name: "shippingEmail",
        label: "E-mailadresse",
      },
    },

    deliveryService: {
      label: "Delivery service",
      name: "deliveryService",
    },
    deliveryDepartment: {
      label: "Delivery department",
      name: "deliveryDepartment",
    },
    deliveryMeta: {
      name: "deliveryMeta",
    },
  },
};
